var D = Object.defineProperty;
var R = (e, t, n) => t in e ? D(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var i = (e, t, n) => R(e, typeof t != "symbol" ? t + "" : t, n);
import { styled as k, Popper as $, useTheme as M, Paper as W, Box as l, Typography as E, Button as F } from "@mui/material";
import r, { useState as c, useRef as v, useEffect as S } from "react";
import { B } from "./chunk.hFvqNSIf.js";
import j from "@mui/material/Fade";
import { C as z } from "./chunk.C6aG2Vyu.js";
const A = k($)(({ theme: e }) => ({
  zIndex: 1,
  "&": {
    borderRadius: "4px"
  },
  "& > div": {
    position: "relative"
  },
  '&[data-popper-placement*="bottom"]': {
    "& > div": {
      marginTop: 16
    },
    "& .MuiPopper-arrow": {
      top: 0,
      left: 0,
      marginTop: "-8px",
      width: "16px",
      height: "8px",
      "&::before": {
        borderWidth: "0 8px 8px 8px",
        borderColor: `transparent transparent ${e.palette.grey[50]} transparent`
      }
    }
  },
  '&[data-popper-placement*="top"]': {
    "& > div": {
      marginBottom: 16
    },
    "& .MuiPopper-arrow": {
      bottom: 0,
      left: 0,
      marginBottom: "-8px",
      width: "16px",
      height: "8px",
      "&::before": {
        borderWidth: "8px 8px 0 8px",
        borderColor: `${e.palette.grey[50]} transparent transparent transparent`
      }
    }
  },
  '&[data-popper-placement*="right"]': {
    "& > div": {
      marginLeft: 16
    },
    "& .MuiPopper-arrow": {
      left: 0,
      marginLeft: "-8px",
      height: "16px",
      width: "8px",
      "&::before": {
        borderWidth: "8px 8px 8px 0",
        borderColor: `transparent ${e.palette.grey[50]} transparent transparent`
      }
    }
  },
  '&[data-popper-placement*="left"]': {
    "& > div": {
      marginRight: 16
    },
    "& .MuiPopper-arrow": {
      right: 0,
      marginRight: "-8px",
      height: "16px",
      width: "8px",
      "&::before": {
        borderWidth: "8px 0 8px 8px",
        borderColor: `transparent transparent transparent ${e.palette.grey[50]}`
      }
    }
  }
})), L = k("div")({
  position: "absolute",
  fontSize: 8,
  width: "16px",
  height: "8px",
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: 0,
    height: 0,
    borderStyle: "solid"
  }
}), o = class o {
  constructor() {
  }
  static getToggletipController() {
    return o.instance || (o.instance = new o()), o.instance;
  }
  static showToggletip(t) {
    for (let n of o.ToggletipIDs)
      n.id === t ? n.setOpen(!0) : n.setOpen(!1);
  }
  registerToggletip(t, n) {
    o.ToggletipIDs ? o.ToggletipIDs.push({ id: t, setOpen: n }) : o.ToggletipIDs = [{ id: t, setOpen: n }];
  }
  unregisterToggletip(t) {
    o.ToggletipIDs = o.ToggletipIDs.filter(
      (n) => n.id !== t
    );
  }
};
i(o, "instance"), i(o, "ToggletipIDs");
let g = o;
const K = (e) => {
  const [t, n] = c(!1), [I, P] = c(null), [s] = c(
    g.getToggletipController()
  ), p = v(null), d = M(), m = v(t);
  m.current = t, S(() => (s.registerToggletip(e.id, (a) => {
    m.current && !a && e.onClose && e.onClose(), n(a);
  }), () => {
    s.unregisterToggletip(e.id);
  }), []);
  const u = {
    bgColor: d.palette.grey[50],
    fontColor: d.palette.grey[900]
  }, f = typeof e.body == "string";
  return /* @__PURE__ */ r.createElement(r.Fragment, null, /* @__PURE__ */ r.createElement("div", { ref: p, style: { display: "inline-block" } }, e.children), /* @__PURE__ */ r.createElement(
    A,
    {
      open: t,
      placement: e.placement ? e.placement : "bottom",
      anchorEl: p.current,
      modifiers: [
        {
          name: "arrow",
          enabled: !0,
          options: {
            element: I
          }
        }
      ],
      transition: !0
    },
    ({ TransitionProps: a }) => {
      var x, b, y, h, C, T;
      return /* @__PURE__ */ r.createElement(j, { ...a, timeout: 350 }, /* @__PURE__ */ r.createElement(
        W,
        {
          sx: {
            padding: 2,
            maxWidth: f ? "320px" : void 0,
            bgcolor: u.bgColor,
            color: u.fontColor
          }
        },
        /* @__PURE__ */ r.createElement(L, { ref: P, className: "MuiPopper-arrow" }),
        /* @__PURE__ */ r.createElement(
          l,
          {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center"
          },
          /* @__PURE__ */ r.createElement(E, { variant: "subtitle1" }, e.title),
          /* @__PURE__ */ r.createElement(
            F,
            {
              "aria-label": "Close",
              onClick: () => {
                var w;
                (w = e.onClose) == null || w.call(e), n(!1);
              },
              sx: { color: "black" }
            },
            /* @__PURE__ */ r.createElement(z, null)
          )
        ),
        /* @__PURE__ */ r.createElement(l, { sx: { marginTop: 2 } }, f ? /* @__PURE__ */ r.createElement(E, { variant: "body1" }, e.body) : /* @__PURE__ */ r.createElement(r.Fragment, null, e.body)),
        ((x = e == null ? void 0 : e.primaryButton) == null ? void 0 : x.onClick) && /* @__PURE__ */ r.createElement(
          l,
          {
            display: "flex",
            flexDirection: "row",
            gap: 1,
            justifyContent: "flex-end",
            marginTop: 3
          },
          ((b = e == null ? void 0 : e.secondaryButton) == null ? void 0 : b.onClick) && /* @__PURE__ */ r.createElement(
            B,
            {
              id: "toggletip-secondary-button",
              buttonText: (y = e.secondaryButton) != null && y.text ? e.secondaryButton.text : "Secondary",
              variant: "outlined",
              onClick: (h = e.secondaryButton) == null ? void 0 : h.onClick
            }
          ),
          /* @__PURE__ */ r.createElement(
            B,
            {
              id: "toggletip-primary-button",
              buttonText: (C = e.primaryButton) != null && C.text ? e.primaryButton.text : "Primary",
              variant: "contained",
              onClick: (T = e.primaryButton) == null ? void 0 : T.onClick
            }
          )
        )
      ));
    }
  ));
};
export {
  K as T,
  g as a
};
